import { IController } from 'angular';
import * as _ from 'lodash';

import { CurrentSchoolYear } from '../../../../../../../../ng2/shared/constants/current-school-year.constant';

export class InstructionsStepCtrl implements IController {
  static inject: string[] = ['$scope', 'WizardUtils'];

  constructor(public $scope, private WizardUtils) {}

  public currentFilter: any;
  public currentLabel;

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.currentFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.currentLabel = this.getLabel();
  }

  hasSuperSeniors() {
    return this.currentFilter && this.currentFilter === CurrentSchoolYear.ENDFULL;
  }

  private getLabel() {
    const status = this.hasSuperSeniors();
    return status === true ? `${this.currentFilter} and older` : this.currentFilter;
  }
}
